import React, { Fragment, useState, useEffect } from "react";
import { Col, Card, CardHeader, CardBody, Form, FormGroup, Label, Row, Input } from 'reactstrap';
import { Btn, H3, Breadcrumbs } from "../../../AbstractElements";
import { Controller, useForm } from 'react-hook-form';
import { useLocation, useNavigate ,Link} from 'react-router-dom';
import { Account, AccountEdi, AccountNo, BankAddress, BankNameText, BankPhone, DefaultActiveAccount, IFSC, Name, OpeningBalance, Save, UpiId, UpiMobile } from "../../../Constant";
import { editAccount, editAccountRole, viewAccount, viewAccountRole } from "../../../CommonUrl";
import { useSelector } from "react-redux";
import { getClientUrlDataToken, postClientUrlWithToken } from "../../../Utils/restUtils";
import { toast } from 'react-toastify';
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import Transparentspinner from "../../Common/Loader/Transparentspinner";

const schema = yup.object().shape({
    name: yup.string().required().label('Name'),
    balance: yup.string().required().label('Opening Balance'),
    accountNo: yup.string().required().label('Account Number'),
    upiId: yup
        .string()
        .notRequired() // Mark the field as optional
        .test(
            'is-valid-upi',
            'UPI ID must be in the correct format (e.g., user@bank).',
            (value) => {
                // Validate format only if a value is provided
                if (!value) return true;
                return /^[a-zA-Z0-9.\-_]{2,}@[a-zA-Z]{2,}$/.test(value);
            }
        )
        .label('UPI ID'),
})

const AccountEdit = () => {
    const { register, handleSubmit, control, setValue, formState: { errors } } = useForm({
        resolver: yupResolver(schema),
    });
    const authState = useSelector((state) => state.auth);
    const [loading, setLoading] = useState(false);
    const [defStatus, setDefStatus] = useState(false);
    const navigate = useNavigate();
    const location = useLocation();
    const searchParams = location.search;
    const params = new URLSearchParams(searchParams);
    const param1 = params.get("id");

    useEffect(() => {
        getSingleIdData();

    }, []);
    const getSingleIdData = async () => {
        setLoading(true);
        let apiData = await getClientUrlDataToken(authState.apiUrl, authState.userRole === 1 ? viewAccount + `?account_id=${param1}` : viewAccountRole + `?account_id=${param1}`);
        if (apiData.status === true) {
            const apiSingleId = apiData?.data[0];
            setValue("name", apiSingleId.name);
            setValue("accountNo", apiSingleId.account_number);
            setValue("balance", apiSingleId.opening_balance);
            setValue("bankName", apiSingleId.bank_name);
            setValue("bankPhone", apiSingleId.bank_phone);
            setValue('ifsc', apiSingleId.ifsc_code);
            setValue('upiMobile', apiSingleId.upi_mobile);
            setValue('upiId', apiSingleId.upi_id);
            setValue("address", apiSingleId.bank_address || "");
            setDefStatus(apiSingleId.default === 'yes');
        } else if (apiData.status >= 400 && apiData.status <= 405) {
            navigate(`${process.env.PUBLIC_URL}/pages/error/error-page1`);
        } else if (apiData.status >= 500 && apiData.status <= 505) {
            navigate(`${process.env.PUBLIC_URL}/pages/error/error-page4`);
        } else {
            navigate(`${process.env.PUBLIC_URL}/pages/error/error-page3`);
        }
        setLoading(false);
    }

    const onSubmit = async (data) => {
        setLoading(true);
        const postRequest = {
            account_id: param1,
            name: data.name,
            opening_balance: data.balance,
            bank_name: data.bankName,
            bank_phone: data.bankPhone,
            bank_address: data.address,
            account_number: data.accountNo,
            ifsc_code: data.ifsc,
            upi_mobile: data.upiMobile,
            upi_id: data.upiId,
            default: defStatus === true ? "yes" : "no",
        }
        const updateAccountResponse = await postClientUrlWithToken(authState.apiUrl, authState.userRole === 1 ?
            editAccount : editAccountRole, postRequest);
        if (updateAccountResponse.status === 200) {
            if (updateAccountResponse.data.status === true) {
                navigate(`${process.env.PUBLIC_URL}/banking/account`);
                toast.success(updateAccountResponse.data.message)
            } else {
                setLoading(false);
                toast.error(addAreaResponse.data.message)
            }
        } else if (updateAccountResponse.status >= 400 && updateAccountResponse.status <= 405) {
            navigate(`${process.env.PUBLIC_URL}/pages/error/error-page1`);
        } else if (updateAccountResponse.status >= 500 && updateAccountResponse.status <= 505) {
            navigate(`${process.env.PUBLIC_URL}/pages/error/error-page4`);
        } else {
            navigate(`${process.env.PUBLIC_URL}/pages/error/error-page3`);
        }
        setLoading(false);
    };
    return (
        <Fragment>
            {loading && (
                <Transparentspinner />
            )}
            <Breadcrumbs mainTitle={Account} parent="Banking" title={AccountEdi} />
            <Card>
                <CardHeader className="pb-0">
                    <H3>{AccountEdi}</H3>
                </CardHeader>
                <CardBody>
                    <Form className="needs-validation" noValidate onSubmit={handleSubmit(onSubmit)}>
                        <Row className="g-3 pt-3">
                            <Col md='6'>
                                <Label className="form-label" for="validationCustom01">{Name} <span className="requireStar">*</span></Label>
                                <input className="form-control" id="validationCustom01" type="text" {...register('name', { required: true })} />
                                <p className="text-danger">{errors.name?.message}</p>
                            </Col>
                            <Col md="6">
                                <Label className="form-label" for="validationCustom02">{AccountNo} <span className="requireStar">*</span></Label>
                                <input className="form-control" id="validationCustom02" type="text" {...register('accountNo', { required: true })} />
                                <p className="text-danger">{errors.accountNo?.message}</p>
                            </Col>
                        </Row>
                        <Row className="g-3 pt-3">
                            <Col md="6">
                                <Label className="form-label" for="validationCustom02">{OpeningBalance} <span className="requireStar">*</span></Label>
                                <input className="form-control" id="validationCustom02" type="text" {...register('balance', { required: true })} />
                                <p className="text-danger">{errors.balance?.message}</p>
                            </Col>
                            <Col md='6'>
                                <Label className="form-label" for="validationCustom01">{BankNameText}</Label>
                                <input className="form-control" id="validationCustom01" type="text" {...register('bankName')} />
                            </Col>
                        </Row>
                        <Row className="g-3 pt-3">
                            <Col md="6">
                                <Label className="form-label" for="validationCustom02">{BankPhone}</Label>
                                <input className="form-control" id="validationCustom02" type="number" min="0" {...register('bankPhone')} />
                            </Col>
                            <Col md="6">
                                <Label className="form-label ">{BankAddress}</Label>
                                <textarea className="form-control" {...register('address')} maxLength={250} />
                            </Col>
                        </Row>
                        {/* <Row className="g-3 pt-3">
                            <Col md="6">
                                <Label className="form-label" for="validationCustom02">{UpiMobile}</Label>
                                <input className="form-control" id="validationCustom02" type="number" min="0" {...register('upiMobile')} />
                            </Col>
                            <Col md="6">
                                <Label className="form-label" for="validationCustom02">{UpiId}</Label>
                                <input className="form-control" id="validationCustom02" type="text" min="0" {...register('upiId')} />
                                <p className="text-danger">{errors.upiId?.message}</p>
                            </Col>
                        </Row> */}
                    
                        <FormGroup>
                        </FormGroup>
                        <div className="d-flex justify-content-center mt-3 gap-2">
                            <Btn attrBtn={{ color: "primary" }} type="submit">
                                {Save}
                            </Btn>
                            <Link to="/banking/account" className="btn btn-light" type="button">
                                Cancel
                            </Link>
                        </div>
                    </Form>
                </CardBody>
            </Card>
        </Fragment>
    )
}
export default AccountEdit;